import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcsysadmin.widget.community.group.info');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";

@Component({
    selector: 'wiz-portal-gsdcsysadmin-widget-community-group-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcsysadmin.widget.community.group.info/view.scss */
/* src/app/portal.gsdcsysadmin.widget.community.group.info/view.scss: no such file or directory */`],
})
export class PortalGsdcsysadminWidgetCommunityGroupInfoComponent implements OnInit, OnDestroy {
    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    constructor(@Inject( Service) public service: Service) { }

    @Input() group: any;
    @Input() community_id: any;
    @Input() target: any;

    public async ngOnInit() {
        await this.service.init();

        let element: any = this.editorElement.nativeElement;
        let toolbar = 'heading | bold italic strikethrough underline | blockQuote code | bulletedList numberedList | outdent indent | uploadImage insertTable link codeBlock horizontalLine'.split(' ');

        this.editor = await ClassicEditor.create(element, {
            toolbar: {
                items: toolbar,
                shouldNotGroupWhenFull: true
            },
            removePlugins: ["MediaEmbedToolbar"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });

        this.editor.data.set(this.group.description);
    }

    public async ngOnDestroy() {
        this.group.description = this.editor.data.get();
    }

    public async update() {
        this.group.description = this.editor.data.get();
        let body = JSON.parse(JSON.stringify(this.group));
        const { code } = await wiz.call("update", { info: JSON.stringify(body) });
        if (code == 200) await this.alert("저장되었습니다", "success");
        else await this.alert("오류가 발생했습니다.", "error");
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }
}

export default PortalGsdcsysadminWidgetCommunityGroupInfoComponent;